import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { ValidationService } from '../validation.service';

export function currencyConversionValidator(service: ValidationService, currency: string): AsyncValidatorFn {
  return (control: AbstractControl): Observable<null | { currencyConversion: boolean }> => {
    return service.validateCurrencyConversion({ amount: control.value, currency });
  }
}
